const digest = 'b63d18407b9b7e3dbbcee53449d956e9fdc818c1fa0b5e7a550e236302aed148';
const css = `._repoSelectControl_eeflc_3{max-width:23rem}._dsc-center_eeflc_8{display:flex;justify-content:center;padding:32px}._dsc-notification_eeflc_15{margin-top:8px}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'repoSelectControl': '_repoSelectControl_eeflc_3', 'dsc-center': '_dsc-center_eeflc_8', 'dsc-notification': '_dsc-notification_eeflc_15' };
export const repoSelectControl = '_repoSelectControl_eeflc_3';
export { css, digest };